import { showNotification } from '@mantine/notifications'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '..'

export const editEmailRecipient = (
  alertRuleId: string,
  recipientId: string,
  email: string,
) =>
  api.put(`/v1/alert-rules/${alertRuleId}/email-recipients/${recipientId}`, {
    email,
  })

export const useEditEmailRecipient = (alertRuleId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      recipientId,
      email,
    }: {
      recipientId: string
      email: string
    }) => editEmailRecipient(alertRuleId, recipientId, email),
    onSuccess: () => {
      queryClient.invalidateQueries([
        'alertRule',
        alertRuleId,
        'emailRecipients',
      ])
      showNotification({
        message: 'Email recipient updated successfully',
        color: 'green',
      })
    },
    onError: () => {
      showNotification({
        message: 'Failed to update email recipient',
        color: 'red',
      })
    },
  })
}
